import { useQuery, gql } from '@apollo/client';

function useTerms() {
  const { loading, data } = useQuery(
    gql`
      query useTerms {
        contentfulSimplePage(id: "eAhrKkNg1vwZGacjAbRjW") {
          title
          updatedDate
          content {
            json
          }
        }
      }
    `,
  );
  return [loading, data?.contentfulSimplePage];
}

export default useTerms;
